import * as HoverCardPrimitive from '@radix-ui/react-hover-card';
import type { ComponentPropsWithoutRef, ElementRef, Ref } from 'react';
import { cn } from '@/lib/utils/style';

const hoverCardAnimationStyle = `@keyframes a2ui-hover-card-in { from { opacity: 0; transform: translate3d(-8px,0,0) scale(.95); } to { opacity: 1; transform: translate3d(0,0,0) scale(1); } } @keyframes a2ui-hover-card-out { from { opacity: 1; transform: scale(1); } to { opacity: 0; transform: scale(.95); } } .a2ui-hover-card-content[data-state="open"] { animation: a2ui-hover-card-in 160ms cubic-bezier(0.22,1,0.36,1); } .a2ui-hover-card-content[data-state="closed"] { animation: a2ui-hover-card-out 120ms ease-in forwards; }`;

export const HoverCard = HoverCardPrimitive.Root;
export const HoverCardTrigger = HoverCardPrimitive.Trigger;

type HoverCardContentProps = ComponentPropsWithoutRef<typeof HoverCardPrimitive.Content> & { ref?: Ref<ElementRef<typeof HoverCardPrimitive.Content>> };

export function HoverCardContent({ className, align = 'center', sideOffset = 4, ref, ...props }: HoverCardContentProps) {
  return (
    <>
      <style>{hoverCardAnimationStyle}</style>
      <HoverCardPrimitive.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        className={cn('a2ui-hover-card-content z-50 w-64 origin-[var(--radix-hover-card-content-transform-origin)] rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none', className)}
        {...props}
      />
    </>
  );
}
